import { Link, useLocation } from "react-router-dom";

export const MobileBookBar = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/book")) return null;

  return (
    <div
      className="safe-bottom fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-black/85 p-3 backdrop-blur-md lg:hidden"
      data-testid="mobile-book-bar"
    >
      <Link
        to="/book"
        data-testid="mobile-book-bar-cta"
        className="block rounded-full bg-hotpink py-3.5 text-center text-xs font-bold uppercase tracking-[0.25em] text-white transition-colors duration-300 active:bg-magenta"
      >
        Book Now
      </Link>
    </div>
  );
};

